import { Collection } from 'modules/core/lib/mobx-rest'

import Group from 'modules/surveys/store/models/Group'

class Groups extends Collection<Group> {
  get cacheKey(): string {
    return 'surveysGroups'
  }
  model() {
    return Group
  }
}

export default new Groups()
